import React from 'react';
import { AppBanner } from '../components/AppBanner'; // Your banner component

// This component takes 'showBanner' prop to decide whether to render the banner
export const AppLayout = ({ children, showBanner = true }) => {
  return (
    <div className="app-main-layout">
      {/* 💡 CONDITIONAL RENDERING: Only show the banner if showBanner is true */}
      {showBanner && <AppBanner />} 
      
      <main className="app-content">
        {children} {/* The specific page component (e.g., HomePage, LoginPage) */}
      </main>
      
      {/* You could add a footer here if needed */}
    </div>
  );
};